import script from "./sf-drawer-toggle.vue?vue&type=script&lang=ts&setup=true"
export * from "./sf-drawer-toggle.vue?vue&type=script&lang=ts&setup=true"

import "./sf-drawer-toggle.vue?vue&type=style&index=0&id=3947f792&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3947f792"]])

export default __exports__